import { SelectItem } from "../Other/SelectItem";

export function resolveEnumOptions(d: { [K: string]: string }): SelectItem[] {
    return Object.keys(d).map(s => ({ label: d[s], value: s }) as any);
}